import { render, staticRenderFns } from "./modalRiwayat.vue?vue&type=template&id=8d12f57c"
import script from "./modalRiwayat.vue?vue&type=script&lang=js"
export * from "./modalRiwayat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports